import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getSystemSettings } from '../store/api/SystemSettingsAPI';
import {getPageFieldListByName } from '../store/api/Users';
import { Link } from 'react-router-dom';
const HomePage = () => {
    const settingNames = ['ProductGrouppingType', 'NationalCodeIsRequired' , 'Services_SerialObligatoryInInstall', 'Services_SerialObligatoryInRepair', "Services_ProductSerial_IsEnglish"];
    const dispatch = useDispatch();
    const [width, setWidth] = useState(window.innerWidth);
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const fieldList = useSelector(state => state.UserReducer.pageFieldList);
    const checkFieldPermission = (fieldName, actionType) => {
        let result = true;
        let field = fieldList?.find(f => f.PageName === "MainPage" && f.Name === fieldName);
        if (actionType === "Read" && field) {            
                result = field.IsRead;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false
        }
        return result;
    }
    useEffect(() => {
        document.body.classList = "";
        if (!systemSettings || systemSettings.length === 0) {
            dispatch(getSystemSettings(settingNames));
        }
        if (!fieldList || fieldList.length === 0) {
            dispatch(getPageFieldListByName(""));
        }
    }, []);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const history = useHistory();
    return (
        <div>
            <img style={{ marginTop: "10px", marginBottom: "10px" }} alt="" />
            <div className="container-fluid mt-1">
                <h2>مدیریت تنظیمات و اطلاعات پایه</h2>
            </div>
        </div>

    )

}

export default HomePage;